import React from "react";
import { AlertCard, Button } from "@truevault/aquilo";
import { useParams } from "react-router";
import { NetworkRequest } from "../../../common/models/NetworkRequest";
import { usePublicDomainSetupInstructions } from "../../hooks/useOrganization";
import { Loading } from "..";
import { DashboardPageWrapper } from "../layout/DashboardPageWrapper";
import { PageHeader } from "../layout/header/Header";
import { PublicDomainSetupInstructions } from "./PublicDomainSetupInstructions";

type UrlParams = {
  id: string;
};

export function PublicDomainSetupPage() {
  const { id } = useParams<UrlParams>();
  const [instructions, request, refresh] = usePublicDomainSetupInstructions(id);

  if (!NetworkRequest.isFinished(request)) {
    return (
      <DashboardPageWrapper>
        <Loading />
      </DashboardPageWrapper>
    );
  }

  return (
    <DashboardPageWrapper>
      <PageHeader
        titleContent="Developer Instructions"
        descriptionContent="Someone from your team has shared these instructions for reviewing your privacy email setup and completing your custom domain."
      />
      {request.error || !instructions ? (
        <div className="tw-boundary">
          <AlertCard
            variant="warning"
            title="These setup instructions couldn’t be loaded."
            description="Check that you have the correct developer link, then try again."
            containerClasses="mt-0 mb-0"
          >
            <div className="mt-[16px]">
              <Button color="primary" size="s" onClick={() => void refresh()}>
                Try again
              </Button>
            </div>
          </AlertCard>
        </div>
      ) : (
        <PublicDomainSetupInstructions instructions={instructions} />
      )}
    </DashboardPageWrapper>
  );
}
